import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { useLocation } from "react-router-dom";
import { createBrowserHistory } from "history";
import { env } from "./envConfig";
import { useEffect } from "react";

export const reactPlugin = new ReactPlugin();
const browserHistory = createBrowserHistory();

export const appInsights = new ApplicationInsights({
  config: {
    connectionString: env.REACT_APP_APPINSIGHTS_CONNECTION_STRING, // or process.env.REACT_APP_...
    extensions: [reactPlugin],
    correlationHeaderExcludedDomains: ["openrouter.ai"],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory }
    },
    // Good defaults
    enableAutoRouteTracking: true, // works best if you use the ReactPlugin with history (see below)
    disableFetchTracking: false,
    disableAjaxTracking: false,
    autoTrackPageVisitTime: true,

    // (Optional) helpful to reduce noise
    enableCorsCorrelation: true
  }
});

// call this once on app startup
export function initAppInsights() {
    // Avoid initializing if not configured (local dev etc.)
    const cs = (env.REACT_APP_APPINSIGHTS_CONNECTION_STRING as string) ?? "";
    if (!cs) {
      // no-op if missing
      return;
    }

    appInsights.loadAppInsights();
    appInsights.trackPageView(); // initial page view
}

export const RouteTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    const msg = `route-change:${location.pathname}:${Date.now()}`;
  
    appInsights.trackTrace({ message: msg });
    appInsights.trackPageView({
      name: location.pathname,
      uri: window.location.href
    });
  }, [location.pathname]);

  return null;
};